import {ApolloClient, ApolloLink, from, fromPromise, gql, HttpLink, InMemoryCache,} from "@apollo/client";
import {onError} from "@apollo/client/link/error";


const REFRESH_TOKEN = gql`
    mutation RefreshAccessToken($input: RefreshAccessTokenInput!) {
        refreshAccessToken(input: $input) {
            accessToken
            refreshToken
            role
        }
    }
`;

let isRefreshing = false;
let pendingRequests = [];

const addPendingRequest = (cb) => {
    pendingRequests.push(cb);
};

const resolvePendingRequests = (token) => {
    pendingRequests.forEach((cb) => cb(token));
    pendingRequests = [];
};

const refreshTokenCall = async () => {
    const refreshToken =
        localStorage.getItem("refreshToken") ||
        sessionStorage.getItem("refreshToken");

    const username =
        localStorage.getItem("username") ||
        sessionStorage.getItem("username");

    if (!refreshToken || !username) {
        return null;
    }


    const {data} = await client.mutate({
        mutation: REFRESH_TOKEN,
        variables: {input: {username, refreshToken}},
        context: {isRefresh: true},
        fetchPolicy: "no-cache",
    });

    return data?.refreshAccessToken;
};

const errorLink = onError(
    ({graphQLErrors, networkError, operation, forward}) => {

        const unauthorized =
            Array.isArray(graphQLErrors) &&
            graphQLErrors.some(
                (err) =>
                    err.extensions?.classification === "UNAUTHORIZED" ||
                    err.extensions?.reason === "TOKEN_EXPIRED"
            ) || networkError?.statusCode === 401;

        if (!unauthorized) return;

        if (!isRefreshing) {
            isRefreshing = true;

            return fromPromise(refreshTokenCall())
                .map((tokens) => {
                    isRefreshing = false;

                    if (!tokens) {

                        localStorage.clear();
                        sessionStorage.clear();
                        window.location.href = "/";
                        return forward(operation);
                    }


                    localStorage.setItem("accessToken", tokens.accessToken);
                    localStorage.setItem("refreshToken", tokens.refreshToken);

                    resolvePendingRequests(tokens.accessToken);

                    operation.setContext(({headers = {}}) => ({
                        headers: {
                            ...headers,
                            Authorization: `Bearer ${tokens.accessToken}`,
                        },
                    }));

                    return forward(operation);
                });
        }

        return fromPromise(
            new Promise((resolve) => {
                addPendingRequest((token) => {
                    operation.setContext(({headers = {}}) => ({
                        headers: {
                            ...headers,
                            Authorization: `Bearer ${token}`,
                        },
                    }));
                    resolve();
                });
            })
        ).map(() => forward(operation));
    }
);


const authLink = new ApolloLink((operation, forward) => {
    const token =
        localStorage.getItem("accessToken") ||
        sessionStorage.getItem("accessToken");
    if (operation.getContext().isRefresh) {
        return forward(operation);
    }
    operation.setContext(({headers = {}}) => ({
        headers: {
            ...headers,
            ...(token ? {Authorization: `Bearer ${token}`} : {}),
        },
    }));

    return forward(operation);
});

const httpLink = new HttpLink({
    uri: "https://api.maksmart.app:8443/api/v1/service",
    // uri: "http://localhost:8080/api/v1/service",

});

const client = new ApolloClient({
    link: from([errorLink, authLink, httpLink]),
    cache: new InMemoryCache(),
});

export default client;
